import { render, staticRenderFns } from "./PendingPositionsList.vue?vue&type=template&id=764f661d&"
import script from "./PendingPositionsList.vue?vue&type=script&lang=js&"
export * from "./PendingPositionsList.vue?vue&type=script&lang=js&"
import style0 from "./PendingPositionsList.vue?vue&type=style&index=0&id=764f661d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports